import mixpanel from 'mixpanel-browser'
import {ExperimentEnum} from "_business";

let isInitialized = false

const initMixpanel = () => {
  if (isInitialized)
    return

  const params = new URLSearchParams(window.location.search)
  const isReplay = params.get('replay') === 'true'

  mixpanel.init(process.env.REACT_APP_MIXPANEL_TOKEN, {
    debug: process.env.REACT_APP_DEBUG,
    track_pageview: false,
    // session_recording: {record: true},
    record_sessions_percent: isReplay ? 100 : 5
  })

  isInitialized = true
}

export const resetMixpanel = () => {
  console.warn('mixpanel reset')

  if (process.env.REACT_APP_DEBUG) {
    const experiments = Object.keys(ExperimentEnum)

    for (const A of experiments)
      window.sessionStorage.removeItem(A)
  }

  mixpanel.reset()
  isInitialized = false
  initMixpanel()

  // mixpanel.unregister('user_goal1')

  // или удалить все вручную:
  // Object.keys(mixpanel.get_property()).forEach(key => mixpanel.unregister(key))

  // mixpanel.people.delete_user() // ❗ удаляет с сервера (если включено)
}

initMixpanel()

export default mixpanel